<template>
  <div>
    <el-table
      :data="StakeholderList"
      border
      style="width: 100%;"
      height="400"
      :style="listHeight"
      @current-change="currentChange"
      highlight-current-row
    >
      <el-table-column prop="USERNAME" label="干系人" width="200"></el-table-column>
      <el-table-column v-if="!isMonitor" label="通知提醒">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.ISNOTICEPERSON" @change="onChange"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column v-if="!isMonitor" label="允许创建子任务">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.ALLOWCREATESUBTASK" disabled></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column v-if="!isMonitor" label="评价人">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.ISEVALUTIONPERSON" @change="onChange"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column v-if="!isMonitor" label="固定干系人">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.FIXEDMEMEBER" disabled></el-checkbox>
        </template>
      </el-table-column>

      <el-table-column label="负责人">
        <template slot-scope="scope">
          <el-checkbox
            v-model="scope.row.ISMONITOR"
            :disabled="isMonitorDisabled(scope.row)"
            @change="onMonitorChange"
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column label="关注度">
        <template slot-scope="scope">
          <el-rate
            v-model="scope.row.FOCUSDEGREE"
            :disabled="isDisabled(scope.row)"
            @change="onFocusDegreeChange"
            :max="3"
          ></el-rate>
        </template>
      </el-table-column>
      <el-table-column v-if="!isMonitor" label="备注" width="170">
        <template slot-scope="scope">
          <div>
            <span
              :style="isEdit&&scope.row===currentRow?'display:none':'display:block'"
              @click="isEdit=true"
            >
              <i class="el-icon-edit"></i>
              {{scope.row.MEMO}}
            </span>
            <el-input
              @blur="saveMemo"
              :style="isEdit&&scope.row===currentRow?'display:block':'display:none'"
              v-model="scope.row.MEMO"
              type="textarea"
              maxlength="20"
              :autosize="{ minRows: 1, maxRows: 2}"
              show-word-limit
            ></el-input>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="button" v-if="!isMonitor">
      <el-button
        type="primary"
        size="mini"
        @click="showDialog"
        icon="el-icon-circle-plus-outline"
      >添加干系人</el-button>
      <el-button type="danger" class="delete" @click="onDelete" size="mini">删除干系人</el-button>
      <el-button
        type="success"
        size="mini"
        @click="remindFocus"
        icon="el-icon-circle-plus-outline"
      >提醒关注</el-button>
    </div>
    <el-dialog title="添加干系人" width="480px" :visible.sync="dialogFormVisible" append-to-body>
      <el-form :model="form">
        <el-row>
          <el-col :span="24">
            <el-form-item
              id="commonSelect"
              label="用户选择"
              :label-width="formLabelWidth"
              style="width: 350px;"
            >
              <ayb-select-user
                @getValue="toGetValue"
                :setWidth="'100%'"
                ref="refStakeholder"
                @setValue="toSetValue"
                @verifyMethod="verifyMethod"
                :myData="obj"
                :myOption="opt"
              ></ayb-select-user>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmit">确 定</el-button>
        <el-button type="danger" @click="dialogFormVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getToken } from "@/util/auth";
import selectTaskStakeholder from "@/components/basicData/selectTaskStakeholder.vue";
import { GetAllContactTaskStakeholder } from "@/api/modules/basicData/personnel";
import {
  RemindTaskMemberFocus,
  GetTaskTypeList,
  GetTaskMemeber,
  GetAllServerCenterByCustomerId,
  AddTaskMemberList,
  DelTaskMemeber,
  UpdateTaskMemberList,
  UpdateTaskMemberFocusDegree,
  UpdateTaskMemberMonitor
} from "@/api/modules/basicData/task";
import $http from "@/api/index";
const cookieUser = getToken();
var person = {
  ID: cookieUser.userId,
  NAME: cookieUser.realName,
  DEPTID: cookieUser.departmentId,
  DEPTNAME: cookieUser.departmentName,
  COMPANYID: cookieUser.organizationId,
  COMPANYNAME: cookieUser.organizationName
};
export default {
  components: {
    selectTaskStakeholder
  },
  props: {
    isMonitor: {
      //是否是负责人设置界面
      type: Boolean,
      default: false
    },
    StakeholderData:{
      type:Array,
      default:()=>{return []}
    }
  },
  data() {
    return {
      isEdit: false,
      obj: {
        idArray: [],
        imageType: [
          {
            type: -2,
            imgPath: require("@/assets/img/机构.png")
          },
          {
            type: -1,
            imgPath: require("@/assets/img/组织.png")
          },
          {
            type: 0,
            imgPath: require("@/assets/img/未知状态.png")
          },
          {
            type: 1,
            imgPath: require("@/assets/img/人员.png")
          },
          {
            type: 2,
            imgPath: require("@/assets/img/人员 (女).png")
          },
          {
            type: 3,
            imgPath: require("@/assets/img/计算机.png")
          },
          {
            type: 4,
            imgPath: require("@/assets/img/分类.png")
          }
        ],
        checkField: {
          Id: "ID", //区别上下级
          Pid: "ParentID",
          Key: "ID", //数据标识，相同key则为同一条数据（例如不同组织下同一人）
          Type: "ContactType", //类型区别字段如Type
          TypeValue: [0, 1, 2, 3], //有效的type值
          ValidField: ["Name"],
          ShowField: "Name",
          ShowFieldName: "姓名"
        }
      },
      opt: {
        commomShowPlaceholder: "", //输入框默认提示
        commonDialogTitle: "添加干系人", //弹出窗标题
        commonCheckedDescription: "已选干系人", //右侧table标题
        isRadio: false //单双选
      },
      degree: 0,
      dialogFormVisible: false,
      currentRow: {}, //当前选中行数据
      EXCUTEUSERID: "",
      EXCUTEUSERNAME: "",
      ReceptionList: [],
      StakeholderArr: [],
      StakeholderList: this.StakeholderData,
      taskLevelSel: "1",
      timetype: "1",
      num6: "1",
      taskLevel: [
        {
          value: "0",
          label: "重要且紧急"
        },
        {
          value: "1",
          label: "重要不紧急"
        },
        {
          value: "2",
          label: "紧急不重要"
        },
        {
          value: "3",
          label: "不重要不紧急"
        }
      ],
      TaskType: "",
      TaskTypeList: "",
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      pickerOptions2: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      value7: "",
      formLabelWidth: "120px"
    };
  },
  created() {
    let a = $(window).height();
    this.listHeight = "height:" + (a - 190) + "px;";
  },
  methods: {
    saveMemo() {
      this.isEdit = false;

      UpdateTaskMemberList([this.currentRow]).then(pmevent => {
        if (pmevent === 1) {
          this.initalTask();
          this.$message({
            type: "success",
            message: "修改成功。"
          });
        } else {
          this.$message({
            type: "error",
            message: "修改失败！"
          });
        }
      });
    },
    remindFocus() {
      //提醒关注
      if (this.currentRow.ID == null) return;
      if (this.currentRow.FOCUSDEGREE == 3) return;
      if (this.currentRow.USERID == person.ID) return;
      RemindTaskMemberFocus(this.currentRow, person).then(result => {
        if (result.ResultCode > 0) {
          this.$message.success("成功发送提醒");
        } else {
          this.$message.error(result.MsgInfo);
        }
      });
    },
    isMonitorDisabled(row) {
      if (this.isMonitor) return false;
      if (row.USERID == this.userId && row.USERID != this.task.EXCUTEUSERID)
        return false;
      else return true;
    },
    isDisabled(row) {
      if (this.isMonitor) return false;
      if (row.USERID == this.userId) return false;
      else return true;
    },
    initalTask() {
      if (!this.task || this.tabIndex !== "9") return;
      GetTaskMemeber(this.task.ID, false).then(res => {
        if (!res) return;
        this.StakeholderList = res;
        var row = this.StakeholderList.find(o => o.USERID == this.userId);
        if (row != null) this.degree = row.FOCUSDEGREE;
      });
    },
    loadTaskMemeber(taskId) {
      GetTaskMemeber(taskId, false).then(res => {
        console.log("loadTaskMemeber", res);
        if (!res) return;
        this.StakeholderList = res;
        var row = this.StakeholderList.find(o => o.USERID == this.userId);
        if (row != null) this.degree = row.FOCUSDEGREE;
      });
    },
    showDialog() {
      this.dialogFormVisible = true;
      this.GetTaskTypeList();
    },
    GetTaskTypeList() {
      //任务类型
      GetTaskTypeList().then(res => {
        this.TaskTypeList = res;
        this.TaskType = res[res.length - 1].ID;
      });
    },
    GetTaskMemeber() {
      (1, true).then(res => {
        this.ReceptionList = res;
      });
    },
    toGetValue(value, callback) {
      console.log("干系人返回值", value);
      this.StakeholderArr = value;
      // 	 if (!value) return;
      //     const row = value[0];
      //    //alert(JSON.stringify(row));
      //     this.EXCUTEUSERID = row.UserId;
      //     this.EXCUTEUSERNAME = row.Name;
      callback(true);
    },
    toSetValue(value, callback) {
      GetAllContactTaskStakeholder("4923", "", 0).then(response => {
        callback(response);
      });
    },
    verifyMethod(value, callback) {
      //验证方法
      var res = {
        status: true,
        message: ""
      };
      callback(res);
    },
    ExcuteUserGetValue(data) {
      // this.form.EXCUTEUSERID=
      if (!data) return;
      const row = data[0];
      this.EXCUTEUSERID = row.UserId;
      this.EXCUTEUSERNAME = row.Name;
    },
    onSubmit() {
      const user = getToken();
      let paras = [];
      for (var i in this.StakeholderArr) {
        const row = this.StakeholderList.filter(
          t => t.USERID == this.StakeholderArr[i].UserId
        );
        if (row.length === 0) {
          paras.push({
            USERID: this.StakeholderArr[i].UserId,
            TASKID: this.task.ID,
            USERTYPE: 0,
            USERNAME: this.StakeholderArr[i].Name,
            // DEPTID: user.departmentId,
            // DEPTNAME: user.departmentName,
            // COMPANYID: user.organizationId,
            // COMPANYNAME: user.organizationName,
            ISNOTICEPERSON: true,
            ALLOWCREATESUBTASK: false,
            SHIELD: false
          });
        }
      }
      if (paras.length === 0) {
        this.$message({
          type: "info",
          message: "干系人不能为空或者干系人已经存在"
        });
        return false;
      }
      let _this = this;
      AddTaskMemberList(paras).then(pmevent => {
        if (pmevent === 1) {
          this.initalTask();
          _this.$refs.refStakeholder.reset();
          _this.loadTaskMemeber(this.task.ID);
          this.dialogFormVisible = false;
          this.$message({
            type: "success",
            message: "添加干系人成功。"
          });
        } else {
          this.$message({
            type: "error",
            message: "添加干系人失败！"
          });
        }
      });
    },
    onChange: function(val) {
      console.log(this.currentRow);
      UpdateTaskMemberList([this.currentRow]).then(pmevent => {
        if (pmevent === 1) {
          this.initalTask();
          this.$message({
            type: "success",
            message: "修改成功。"
          });
        } else {
          this.$message({
            type: "error",
            message: "修改失败！"
          });
        }
      });
    },
    onFocusDegreeChange: function(val) {
      if (this.isMonitor) return val;
      console.log("onFocusDegreeChange", this.degree, val);
      if (this.degree == val && val != 0) {
        UpdateTaskMemberFocusDegree(this.task.ID, this.userId, 0).then(
          result => {
            if (result === 1) {
              this.degree = 0;
              this.currentRow.FOCUSDEGREE = 0;
              this.initalTask();
              this.$message({
                type: "success",
                message: "修改成功。"
              });
            } else {
              this.$message({
                type: "error",
                message: "修改失败！"
              });
            }
          }
        );
      } else {
        UpdateTaskMemberFocusDegree(this.task.ID, this.userId, val).then(
          result => {
            if (result === 1) {
              this.degree = val;
              this.initalTask();
              this.$message({
                type: "success",
                message: "修改成功。"
              });
            } else {
              this.$message({
                type: "error",
                message: "修改失败！"
              });
            }
          }
        );
      }
    },
    onMonitorChange: function(val) {
      if (this.isMonitor) return val;
      UpdateTaskMemberMonitor(this.task.ID, person, val).then(pmevent => {
        if (pmevent === 1) {
          this.initalTask();
          this.$message({
            type: "success",
            message: "修改成功。"
          });
        } else {
          this.$message({
            type: "error",
            message: "修改失败！"
          });
        }
      });
    },
    onDelete: function() {
      if (this.currentRow.ID == null) return;
      if (this.currentRow.FIXEDMEMEBER) {
        this.$message({
          type: "info",
          message: "当前干系人是固定干系人，不能删除。"
        });
        return;
      }
      DelTaskMemeber(this.currentRow.ID).then(pmevent => {
        if (pmevent === 1) {
          this.initalTask();
          this.loadTaskMemeber(this.task.ID);
          this.$message({
            type: "success",
            message: "删除干系人成功。"
          });
        } else {
          this.$message({
            type: "error",
            message: "删除干系人失败！"
          });
        }
      });
    },
    /**选择行事件 */
    currentChange: function(currentRow, oldCurrentRow) {
      if (this.isMonitor) return;
      this.currentRow = currentRow;
      this.isEdit = false;
    }
  },
  computed: {
    ...mapState({
      task: state => state.task.curTask,
      userId: state => state.task.userId
    }),
    task: function() {
      return this.$store.state.task.curTask;
    },
    tabIndex: function() {
      return this.$store.state.task.tabIndex;
    }
  },
  watch: {
    // task: function(newvalue) {
    //   if (!newvalue) return;
    //   this.initalTask();
    // },
    // tabIndex: function(newvalue) {
    //   if (!newvalue) return;
    //   this.initalTask();
    // }
  }
};
</script>

<style scoped>
.el-tabs__content {
  line-height: 20px;
}

.el-table__row {
  line-height: 20px;
}

.has-gutter tr {
  background-color: #f3f3f3;
  height: 38px;
}

.el-table__body-wrapper {
  background-color: white;
}

.el-table .cell {
  line-height: 13px;
}

.el-table__row .el-table_1_column_1,
.el-table__row .el-table_1_column_2 {
  color: #0099ff;
}

.button .el-button {
  background: #ecf5ff;
  color: #0099ff;
}

.button .delete {
  background: #f9ebed;
  color: #f02d52;
  border: solid 1px #f02d52;
}

.button {
  margin: 15px 0 15px 20px;
  float: left;
}

.el-dialog__header {
  text-align: left;
}

.el-dialog__body {
  border-top: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  text-align: left;
}
</style>
